import { render, staticRenderFns } from "./SeminarRowStat.vue?vue&type=template&id=4b89ad2b&scoped=true&"
import script from "./SeminarRowStat.vue?vue&type=script&lang=js&"
export * from "./SeminarRowStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89ad2b",
  null
  
)

export default component.exports